import { Page } from '@/core/architecture'

import { ConsoleOfficialInformationCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleOfficialInformationCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleOfficialInformationCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleOfficialInformationCreateTemplate state={state} {...actions} />
}
